import { useFormikContext } from 'formik';
import React from 'react';
import { Card } from 'react-bootstrap';

import { useWhyDidYouUpdate } from '../../hooks';

import { ButtonBack, FlexRow } from './../index';

const headerPadding = {
  margin: '0.0rem 0.5rem',
};

type Props = {
  /** Title of form (string or ReactNode e.g. spinner when loading) */
  readonly title: React.ReactNode;
  /** Optional title suffix muted */
  readonly idx?: number;
  /** Optional onReturn event, enabled only if form is not dirty */
  readonly onReturn?: () => void;
  /**  Optional Header Buttons */
  readonly injectHeaderElements?: () => React.ReactNode;
};

const FormHeader = ({
  title,
  idx = null,
  onReturn = null,
  injectHeaderElements,
}: Props) => {
  useWhyDidYouUpdate('[FormHeader]', { title, idx, onReturn });
  const { dirty } = useFormikContext();
  return (
    <Card.Header>
      <FlexRow>
        <Card.Title className="m-0">
          {title}
          {/* {!!idx && <span className="text-muted">{` (${idx})`}</span>} */}
          {!!idx && idx > 0 && (
            <span className="text-sm">&nbsp;&nbsp;{idx}</span>
          )}
        </Card.Title>
        <FlexRow
          id="header-button-row"
          style={{ justifyContent: 'flex-start' }}
        >
          {/* -------- INJECT BUTTONS ---------- */}
          {injectHeaderElements && (
            <div id="injectHeaderElements" style={headerPadding}>
              {injectHeaderElements()}
            </div>
          )}
          {!!onReturn && <ButtonBack onClick={onReturn} />}
        </FlexRow>
      </FlexRow>
    </Card.Header>
  );
};

export default React.memo(FormHeader);

